module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0, false, false)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', [_c('div', {
    staticClass: "container"
  }, [_c('ol', {
    staticClass: "breadcrumb hidden-xs"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "/"
    }
  }, [_vm._v("首頁")])]), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v("FAQ")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-smmd-offset-2 col-sm-8"
  }, [_c('h4', {
    staticClass: "text-center title"
  }, [_vm._v("FAQ")]), _vm._v(" "), _c('div', {
    staticClass: "panel-group",
    attrs: {
      "id": "accordion faq",
      "role": "tablist",
      "aria-multiselectable": "true"
    }
  }, [_c('div', {
    staticClass: "panel panel-default faq_box"
  }, [_c('div', {
    staticClass: "panel-heading",
    attrs: {
      "role": "tab",
      "id": "headingOne"
    }
  }, [_c('h4', {
    staticClass: "panel-title title"
  }, [_c('a', {
    attrs: {
      "role": "button",
      "data-toggle": "collapse",
      "data-parent": "#accordion",
      "href": "#collapseOne",
      "aria-expanded": "true",
      "aria-controls": "collapseOne"
    }
  }, [_vm._v("\n                                      會員回饋金何時發放?\n                                  ")])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse in",
    attrs: {
      "id": "collapseOne",
      "role": "tabpanel",
      "aria-labelledby": "headingOne"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_vm._v("\n                                  會員於上個月進行消費所產生的點數，以及包含推薦的會員消費，系統會統一進行計算後於隔月15號一併發放回饋金給會員，並且保存於會員中心的紀錄中。\n                              ")])])]), _vm._v(" "), _c('div', {
    staticClass: "panel panel-default faq_box"
  }, [_c('div', {
    staticClass: "panel-heading",
    attrs: {
      "role": "tab",
      "id": "headingTwo"
    }
  }, [_c('h4', {
    staticClass: "panel-title title"
  }, [_c('a', {
    staticClass: "collapsed",
    attrs: {
      "role": "button",
      "data-toggle": "collapse",
      "data-parent": "#accordion",
      "href": "#collapseTwo",
      "aria-expanded": "false",
      "aria-controls": "collapseTwo"
    }
  }, [_vm._v("\n                              會員如何進行消費與分享?\n                              ")])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse",
    attrs: {
      "id": "collapseTwo",
      "role": "tabpanel",
      "aria-labelledby": "headingTwo"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_vm._v("\n                                  您只要註冊帳號後系統將會給你一組會員編號，您可以透過分享網址船給您的朋友，讓朋友進行註冊後就算是完成推薦的動作了，爾後當您的朋友購買任何商品都會直接回饋給您。\n                              ")])])]), _vm._v(" "), _c('div', {
    staticClass: "panel panel-default faq_box"
  }, [_c('div', {
    staticClass: "panel-heading",
    attrs: {
      "role": "tab",
      "id": "headingThree"
    }
  }, [_c('h4', {
    staticClass: "panel-title title"
  }, [_c('a', {
    staticClass: "collapsed",
    attrs: {
      "role": "button",
      "data-toggle": "collapse",
      "data-parent": "#accordion",
      "href": "#collapseThree",
      "aria-expanded": "false",
      "aria-controls": "collapseThree"
    }
  }, [_vm._v("\n                                  如果我有認識的好的商品或店家，可以進行推薦嗎?\n                                  ")])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse",
    attrs: {
      "id": "collapseThree",
      "role": "tabpanel",
      "aria-labelledby": "headingThree"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_vm._v("\n                                  一定可以的!我們的平台需要優質的商品來提供給會員，因此歡迎您提供我們商家的連絡資訊與商品項目，來讓我們進行接洽服務更多會員。\n                              ")])])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-aa7d56f4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Faq.vue
// module id = 317
// module chunks = 1